export default __webpack_public_path__ + "static/media/weather_dash.8241a638.png";